// import React, { useState } from "react";
// import {
//   TextField,
//   Button,
//   IconButton,
//   InputAdornment,
//   Typography,
//   Box,
//   Paper,
// } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";

// export default function PartnerSignupPage() {
//   const [form, setForm] = useState({
//     hotelName: "",
//     name: "",
//     email: "",
//     phone: "",
//     password: "",
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const validatePassword = (password) => {
//     const regex =
//       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
//     return regex.test(password);
//   };

//   const handleSignup = async (e) => {
//     e.preventDefault();
//     const { hotelName, name, email, phone, password } = form;

//     if (!hotelName || !name || !email || !phone || !password) {
//       setError("Please fill in all fields.");
//       return;
//     }

//     if (!validatePassword(password)) {
//       setError(
//         "Password must be at least 8 characters and include uppercase, lowercase, number, and special character."
//       );
//       return;
//     }

//     try {
//       setLoading(true);
//       setError("");

//       const res = await fetch("https://jsonplaceholder.typicode.com/users", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });

//       const data = await res.json();
//       console.log("Partner Signup success:", data);
//       toast.success("Your partner account has been created successfully!");
//     } catch (err) {
//       console.error("Signup failed:", err);
//       setError("Signup failed. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         bgcolor: "#f3f4f6",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         p: 2,
//       }}
//     >
//       <Paper elevation={4} sx={{ p: 4, maxWidth: 450, width: "100%" }}>
//         <Typography variant="h5" gutterBottom align="center" fontWeight="bold">
//           Join YOVHO Partner
//         </Typography>
//         <Typography variant="body2" align="center" sx={{ mb: 2 }}>
//           Fill in your details to create your vendor account
//         </Typography>

//         {error && (
//           <Typography color="error" align="center" sx={{ mb: 2 }}>
//             {error}
//           </Typography>
//         )}

//         <form onSubmit={handleSignup}>
//           <TextField
//             label="Hotel / Property Name"
//             name="hotelName"
//             fullWidth
//             value={form.hotelName}
//             onChange={handleChange}
//             margin="normal"
//           />
//           <TextField
//             label="Your Full Name"
//             name="name"
//             fullWidth
//             value={form.name}
//             onChange={handleChange}
//             margin="normal"
//           />
//           <TextField
//             label="Email"
//             name="email"
//             type="email"
//             fullWidth
//             value={form.email}
//             onChange={handleChange}
//             margin="normal"
//           />
//           <TextField
//             label="Phone Number"
//             name="phone"
//             type="tel"
//             fullWidth
//             value={form.phone}
//             onChange={handleChange}
//             margin="normal"
//             inputProps={{ maxLength: 15 }}
//           />
//           <TextField
//             label="Password"
//             name="password"
//             fullWidth
//             type={showPassword ? "text" : "password"}
//             value={form.password}
//             onChange={handleChange}
//             margin="normal"
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton
//                     onClick={() => setShowPassword(!showPassword)}
//                     edge="end"
//                   >
//                     {showPassword ? <VisibilityOff /> : <Visibility />}
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <Button
//             type="submit"
//             variant="contained"
//             color="primary"
//             fullWidth
//             sx={{ mt: 2 }}
//             disabled={loading}
//             style={{background :"#002776"}}
//           >
//             {loading ? "Creating account..." : "Join as Partner"}
//           </Button>
//         </form>

//         <Typography variant="body2" align="center" sx={{ mt: 2 }}>
//           By signing up, you agree to our{" "}
//           <a href="/partners-term-condition" style={{ color: "#002776" }}>
//             Terms & conditons
//           </a>{" "}
//           and{" "}
//           <a href="/privacy" style={{ color: "#002776" }}>
//             Privacy Policy
//           </a>
//           .
//         </Typography>
//       </Paper>
//     </Box>
//   );
// }









import React, { useState } from "react";
import {
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Typography,
  Box,
  Paper,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function PartnerSignupPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("signup"); // signup → verify
  const [serverCode, setServerCode] = useState(""); // OTP from backend
  const [userCode, setUserCode] = useState(""); // OTP user enters

  // ✅ handle input change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ✅ password validation
  const validatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(password);
  };

  // ✅ Step 1 → Register
  const handleSignup = async (e) => {
    e.preventDefault();
    const { fullName, email, phoneNumber, password } = form;

    if (!fullName || !email || !phoneNumber || !password) {
      setError("Please fill in all fields.");
      return;
    }

    if (!validatePassword(password)) {
      setError(
        "Password must be at least 8 characters and include uppercase, lowercase, number, and special character."
      );
      return;
    }

    try {
      setLoading(true);
      setError("");

      const res = await fetch(
        "https://striking-dedication-production.up.railway.app/api/v1/vendor/auth/register",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        }
      );

      const data = await res.json();
      console.log("Register response:", data);

      if (data?.success) {
        // backend OTP code (demo only)
        setServerCode(data.data.otp || ""); 
        setStep("verify");
      } else {
        setError(data.message || "Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("Signup failed:", err);
      setError("Signup failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Step 2 → Verify OTP
  const handleVerify = async () => {
// const data1 = {
//     "fullName": fullName,
//     "email": email,
//     "password": password,
//     "phoneNumber": phoneNumber
// }
    if (!userCode) {
      setError("Please enter the verification code.");
      return;
    }

    try {
      setLoading(true);
      setError("");
      if(userCode == serverCode){
      // Send verify request to backend
      const res = await fetch(
        "https://striking-dedication-production.up.railway.app/api/v1/vendor/auth/verify-register-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
          ...form
          }),
        }
      );

      const data = await res.json();
      console.log("Verify response:", data);

      if (data.success && data.data?.token) {
        // save login token & user
        localStorage.setItem("authToken", data.data.token);
        localStorage.setItem("user", JSON.stringify(data.data.user));

        toast.success("Your partner account has been created successfully!");
        navigate("/partner/dashboard");
      } else {
        setError(data.message || "Invalid verification code.");
      }
    }else {
        setError("Invalid verification code.");
      }
    } catch (err) {
      console.error("Verification failed:", err);
      setError("Verification failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f3f4f6",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
      }}
    >
      <Paper elevation={4} sx={{ p: 4, maxWidth: 450, width: "100%" }}>
        {step === "signup" && (
          <>
            <Typography variant="h5" gutterBottom align="center" fontWeight="bold">
              Join YOVHO Partner
            </Typography>
            <Typography variant="body2" align="center" sx={{ mb: 2 }}>
              Fill in your details to create your vendor account
            </Typography>

            {error && (
              <Typography color="error" align="center" sx={{ mb: 2 }}>
                {error}
              </Typography>
            )}

            <form onSubmit={handleSignup}>
              <TextField
                label="Full Name"
                name="fullName"
                fullWidth
                value={form.fullName}
                onChange={handleChange}
                margin="normal"
              />
              <TextField
                label="Email"
                name="email"
                type="email"
                fullWidth
                value={form.email}
                onChange={handleChange}
                margin="normal"
              />
              <TextField
                label="Phone Number"
                name="phoneNumber"
                type="tel"
                fullWidth
                value={form.phoneNumber}
                onChange={handleChange}
                margin="normal"
                inputProps={{ maxLength: 15 }}
              />
              <TextField
                label="Password"
                name="password"
                fullWidth
                type={showPassword ? "text" : "password"}
                value={form.password}
                onChange={handleChange}
                margin="normal"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{ mt: 2, bgcolor: "#002776" }}
                disabled={loading}
              >
                {loading ? "Creating account..." : "Join as Partner"}
              </Button>
            </form>
          </>
        )}

        {step === "verify" && (
          <>
            <Typography variant="h5" gutterBottom align="center" fontWeight="bold">
              Verify Your Email
            </Typography>

            {error && (
              <Typography color="error" align="center" sx={{ mb: 2 }}>
                {error}
              </Typography>
            )}

            <TextField
              label="Verification Code"
              fullWidth
              value={userCode}
              onChange={(e) => setUserCode(e.target.value)}
              margin="normal"
            />

            <Button
              variant="contained"
              fullWidth
              sx={{ mt: 2, bgcolor: "#002776" }}
              onClick={handleVerify}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify & Complete Signup"}
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
}
